export const SIGN_UP =  "SIGN_UP"
export const LOG_IN =  "LOG_IN"
export const LOGOUT = 'LOGOUT';

export const RESET_PASSWORD = "RESET_PASSWORD"
export const PASSWORD_CHANGE = "PASSWORD_CHANGE"
export const GET_TOKENS = "GET_TOKENS"